import React, {useRef, useEffect, useState} from 'react';
import JqxGrid from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.ui-overcast.css';
// import 'jqwidgets-scripts/jqwidgets/styles/jqx.blue.css';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

interface Row {
    [key: string]: any;
}

interface Column {
    id: string;
    label: string;
    type: string;
}

interface IProps {
    data: Row[];
    columns: Column[];
    title: string;
    tableHeight: any;
    tableWidth: any;
}

const PotentialProjectGrid: React.FC<IProps> = ({data, columns}) => {
    const jqxGridRef = useRef<JqxGrid>(null);
    const [source, setSource] = useState<any>(undefined);
    const [columnsState, setColumnsState] = useState<any[]>([]);
    const [isDataReady, setIsDataReady] = useState<boolean>(false);
    const contentDivHeight = useSelector((state: any) => state.base.contentDivHeight);
    const headerHeight = 30;
    const rowPadding = 10;
    const [paperHeight, setPaperHeight] = useState(0);

    React.useEffect(() => {
        const height = contentDivHeight - 2 * rowPadding - headerHeight - 5;
        setPaperHeight(height);
    }, [contentDivHeight]);

    const calculateColumnWidth = (columnId: string, columnName: string): number => {
        const maxLengthName = columnName.length;
        const maxLengthContent = Math.max(
            ...data.map((row) => {
                const value = row[columnId];
                return value ? value.toString().length : 0;
            })
        );
        const maxCellSize = 250; // Set a maximum width if needed
        const minWidth = 80; // Set a minimum width if needed

        // Calculate the width based on the maximum of name length and content length
        const width = Math.max(maxLengthName, maxLengthContent) * 10;

        return Math.min(maxCellSize, Math.max(minWidth, width));
    };

    useEffect(() => {
        if (!source && columns.length > 0) {
            const datafields = columns.map((col) => ({name: col.id, type: col.type}));
            const newSource = {
                datafields: datafields,
                datatype: 'array',
                localdata: data,
            };
            setSource(newSource);
        }
        if (columnsState.length === 0 && columns.length > 0) {
            const excludedColumns = ['id', 'project_id']; // Columns to exclude
            const newColumns = columns
                .filter((col) => !excludedColumns.includes(col.id))
                .map((col) => ({
                    text: col.label.toUpperCase(),
                    datafield: col.id,
                    width: calculateColumnWidth(col.id, col.label),
                    aggregates: col.type !== 'string' ? ['sum'] : [],
                    //@ts-ignore
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
                        // Customize the rendering for numeric columns
                        if (col.type === 'number') {
                            return `<div style="text-align: center; font-weight: bold; line-height: ${columnproperties.cellsheight}px;">${value}</div>`;
                        }
                        return defaulthtml;
                    },
                }));
            setColumnsState(newColumns);
            setIsDataReady(true);
        }
    }, [data, columns, source, columnsState]);

    const navigate = useNavigate();

    const handleRowClick = (rowIndex: number): void => {
        console.log(rowIndex)
        const selectedRowData = jqxGridRef.current?.getrowdata(rowIndex);
        console.log(selectedRowData)
        if (selectedRowData && selectedRowData.id) {
            // Navigate to the projectInfo page with the selected row's ID
            navigate(`/projectInfo?id=${selectedRowData.id}`);
        }
    };

    const renderToolbar = (toolbar: any): void => {
        let container;
        if(toolbar[0].children.length === 0) {
            container = document.createElement('div');
            container.style.margin = '5px';
            toolbar[0].appendChild(container);
        } else {
            container = toolbar[0].children[0]
        }


        if (container.children.length === 0) {
            const button = document.createElement('div');
            container.appendChild(button);
            button.style.cssText = 'cursor: pointer; float: left; margin-left: 5px;';
            button.className = 'jqx-grid-custom-toolbar-button';
            button.innerHTML = `<img src='https://cdn3.iconfinder.com/data/icons/feather-5/24/search-1024.png' width="24" height="24" alt="Project Details"/> Show Project Details`;

            button.addEventListener('click', () => {
                const selectedRowIndex = jqxGridRef.current?.getselectedrowindex();
                // console.log(selectedRowIndex)
                if (selectedRowIndex !== undefined && selectedRowIndex !== -1) {
                    handleRowClick(selectedRowIndex);
                } else {
                    alert('No row selected');
                }
            });

        }


    };

    return (
        <React.Fragment>
            {isDataReady && (
                <JqxGrid
                    ref={jqxGridRef}
                    width={'100%'}
                    source={source}
                    columns={columnsState}
                    height={paperHeight}
                    autoheight={true}
                    autorowheight={true}
                    sortable={true}
                    altrows={true}
                    enabletooltips={true}
                    editable={false}
                    theme={'classic'}
                    filterable={true}
                    pageable={false}
                    pagesize={100}
                    groupable={true}
                    groups={['region']}
                    groupsexpandedbydefault={true}
                    showtoolbar={false}
                    // rendertoolbar={(toolbar) => {
                    //     !isToolbarRendered && renderToolbar(toolbar)
                    //     setIsToolbarRendered(true)
                    // }}

                />
            )}
        </React.Fragment>
    );
};

export default PotentialProjectGrid;
